import { DictionariesService } from "@sa/rep-mdm";
import { useEffect, useState } from "react";
import { useHookSubscribe } from "../../react-rxjs";
import { ServicesMaps } from "../MapReportingProvider";
import { MapDataSource } from "../models/MapDataSource";
import { MapDimension } from "../models/MapDimension";
import { MapDimensionType } from "../models/MapDimension";
import { useMapStore } from "./useMapStore";
import { useService } from "./useService";

export function useMapFavouriteName() {
  const [dimensionsDisplay, setDimensionsDisplay] = useState("");
  const store = useMapStore();
  const dataSource = useHookSubscribe<null | MapDataSource>(null, store.dataSource$);
  const dictionariesService = useService<DictionariesService>(ServicesMaps.Dictionaries);
  const dimensions = useHookSubscribe<MapDimension[]>([], store.dimensions$);
  const visibleDimensions = dimensions.filter((e) => e.visible).filter((e) => e.type !== MapDimensionType.Calendar);

  useEffect(() => {
    setDimensionsDisplay("");
  }, [dataSource]);

  useEffect(() => {
    const values = {};
    const subscribtions = visibleDimensions.map((dim) => {
      const stream$ = store.dimensionsValues.get(dim?.id || -1);
      if (stream$) {
        return stream$.subscribe((val) => {
          values[dim.id] = val;
          const arrayItemsPrms = visibleDimensions.map((e) => fetchItems(e, dictionariesService));
          Promise.all(arrayItemsPrms).then(async (arrayItems) => {
            const names = visibleDimensions.map((dimension, i) => {
              const value = values[dimension.id];
              const items = arrayItems[i];
              const item = items?.find((e) => e.id === value);
              return item?.name || "";
            });
            setDimensionsDisplay(names.filter(Boolean).join(", "));
          });
        });
      }
    });

    return () => {
      subscribtions.forEach((e) => e?.unsubscribe());
    };
  }, [visibleDimensions]);

  const loadingDataSources = useHookSubscribe<boolean>(true, store.loadingDataSources$);
  const loadingDimensions = useHookSubscribe<boolean>(true, store.loadingDimensions$);
  const loading = loadingDataSources || loadingDimensions || !dimensionsDisplay;
  return loading ? "" : [dataSource?.name, dimensionsDisplay].filter(Boolean).join(" - ");
}

async function fetchItems<T = unknown>(dimension: MapDimension, dictionariesService: DictionariesService) {
  const dictionary = await dictionariesService.getDictionary({ id: dimension.identifier, parameters: {} });
  const items = await dictionary.getAll();
  return items.map((e) => ({
    id: e.getValue<T>("id"),
    name: (typeof e.getValue("name") === "object" ? e.getValue<object>("name")?.[9] : e.getValue<string>("name")) || "",
    parent: e.values["parent"],
  }));
}
